import { postJsMessage } from '../../bridge';
import API from '../../api';
import { isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import type { ClipboardData } from './types';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * clipboard.read
 *
 * [PLATFORM]
 * mac        6.5.0
 * windows    6.1.0
 * linux      6.1.0
 * ios        6.6.0
 * android    6.1.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function read(): Promise<NativeAPIResponseMessage<ClipboardData>> {
  await isAvailable('clipboard.read');
  return postJsMessage<any, ClipboardData>(API.clipboardRead, {});
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * clipboard.write
 *
 * [PLATFORM]
 * mac        6.5.0
 * windows    6.5.5
 * linux      6.5.5
 * ios        6.4.5
 * android    6.1.0
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function write(
  data: ClipboardData
): Promise<NativeAPIResponseMessage<any>> {
  await isAvailable('clipboard.write');
  return postJsMessage(API.clipboardWrite, { ...data });
}

export default {
  read,
  write,
};
